module.exports = __webpack_public_path__ + "static/media/medvatic.2fdf415e.png";